// @flow

import * as React from 'react';
import styles from './ProfileLoader.scss';

import { Spinner } from 'dibs-elements/exports/Spinner';

export function Loader() {
    return (
        <div className={styles.wrapper}>
            <Spinner dark />
        </div>
    );
}
